import { render, staticRenderFns } from "./PredictiveSection.vue?vue&type=template&id=0a2c2f1a&scoped=true&"
import script from "./PredictiveSection.vue?vue&type=script&lang=js&"
export * from "./PredictiveSection.vue?vue&type=script&lang=js&"
import style0 from "./PredictiveSection.vue?vue&type=style&index=0&id=0a2c2f1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2c2f1a",
  null
  
)

export default component.exports